import {
  NEW_WORKFORCEM_FIELD_CHANGE,
  OPEN_NEW_WORKFORCE_MEMBER_DIALOG,
  CLOSE_NEW_WORKFORCE_MEMBER_DIALOG,
  WORKFORCE_REGISTRATION_ERROR,
  ADD_NEW_WORKFORCE_MEMBER,
  NEW_WORKFORCE_MEMBER_ADDED,
} from './actions';

const initialState = {
  pending: false,
  isDirty: false,
  open: false,
  error: null,
  isValid: true,
  data: null,
  firstName: {
    value: '',
    isValid: null,
  },
  lastName: {
    value: '',
    isValid: null,
  },
  email: {
    value: '',
    isValid: null,
  },
  password: {
    value: '',
    isValid: null,
  },
};

const newGroupReducer = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_NEW_WORKFORCE_MEMBER_DIALOG:
      return {
        ...state,
        open: true,
      };

    case CLOSE_NEW_WORKFORCE_MEMBER_DIALOG:
      return {
        ...state,
        open: false,
      };

    case NEW_WORKFORCEM_FIELD_CHANGE:
      return {
        ...state,
        [action.prop]: {
          value: action.value,
          isValid: action.isValid,
        },
      };

    case ADD_NEW_WORKFORCE_MEMBER:
      return {
        ...state,
        pending: true,
      };

    case WORKFORCE_REGISTRATION_ERROR:
      return {
        ...state,
        error: action.err,
        pending: false,
      };

    case NEW_WORKFORCE_MEMBER_ADDED:
      return initialState;

    default:
      return state;
  }
};

export default newGroupReducer;
